import { render, staticRenderFns } from "./Quantidade.vue?vue&type=template&id=0fd1f0bf&scoped=true"
import script from "./Quantidade.vue?vue&type=script&lang=js"
export * from "./Quantidade.vue?vue&type=script&lang=js"
import style0 from "./Quantidade.vue?vue&type=style&index=0&id=0fd1f0bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1f0bf",
  null
  
)

export default component.exports